import { useEffect, useState } from "react";
import { IOilRefieneryContainerProps } from "./OilRefienery.interfaces";
import OilRefieneryView from "./OilRefienery.view";
import BroswerService from "../../Services/Browser.service";
export default function OilRefieneryContainer(
    props: IOilRefieneryContainerProps
) {
    // Scroll to specific section function
    const scrollToOilRefinerySection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Add highlight effect
            element.classList.add('scroll-highlight');
            setTimeout(() => {
                element.classList.remove('scroll-highlight');
            }, 2000);
        }
    };

    useEffect(() => {
        BroswerService.setCustomTitle("OilRefieneryContainer");

        // Check if there's a pending scroll request from navigation
        const pendingScrollSection = sessionStorage.getItem('scrollToOilRefinerySection');
        if (pendingScrollSection) {
            // Wait a bit for the component to fully render
            setTimeout(() => {
                scrollToOilRefinerySection(pendingScrollSection);
                sessionStorage.removeItem('scrollToOilRefinerySection');
            }, 800); // Increased timeout to ensure all content is loaded
        }
    }, []);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    return (
        <>
            <OilRefieneryView
                demoController={demoController}
                showDemo={showDemo}
                loginController={loginController}
                showlogin={showlogin}
                scrollToOilRefinerySection={scrollToOilRefinerySection}
            />
        </>
    );
}
